/**
 * Helpers for local clock dates and timezone-independent calendar-date display.
 *
 * The tempting one-liner, `new Date().toISOString().slice(0, 10)`, returns the
 * UTC date. Everywhere west of Greenwich that is tomorrow for part of every
 * evening, so any value defaulted from it gets filed under the wrong day.
 */

/** Today's local calendar date as YYYY-MM-DD. */
export const todayLocal = () => {
  const d = new Date();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
};

/** Calendar dates keep their day; timestamps retain local-time display. */
export const formatShortDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const dateOnly = typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    ...(dateOnly ? { timeZone: "UTC" } : {}),
  }).format(date);
};
